var React = require('react');

function Logs (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"web/routes/logs"),React.createElement("path",{"d":"M82 0h112.73v404.908h222.393V500H82z","fillRule":"evenodd","fill":"currentColor","key":1})]);
}

Logs.defaultProps = {"width":"500","height":"500","viewBox":"0 0 500 500"};

module.exports = Logs;

Logs.default = Logs;
